module.exports = __webpack_public_path__ + "img/pickChatIcon.9557ed46.png";